class PlayerPassportsController {
  constructor() {
  	"ngInject";
  	const vm = this;
  }
}

export default PlayerPassportsController;



// WEBPACK FOOTER //
// ./client/app/components/players/playerProfile/playerPassports/playerPassports.controller.js